import React from 'react'

import SideSection from '../../hocs/SideSection'

const TakingActionPanel = () => {
  return <></>
}

export default SideSection(TakingActionPanel)
